/* eslint-disable no-alert */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Input } from '@orobix/orobix-fe-components'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useAuth } from '../../auth/AuthProvider'
import { locations } from '../../utils/locations'
import { useStyles } from './LoginRoot.styles'

interface LoginRootProps {
  onSubmit?: (username: string, password: string) => Promise<void>
}

export const LoginRoot: React.FC<LoginRootProps> = () => {
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [error, setError] = useState<string | null>(null)
  const history = useHistory()
  const { login } = useAuth()
  const classes = useStyles()

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setError(null)
    try {
      await login(username, password)
      history.push(locations.datasets)
    } catch (e) {
      setError('Failed to log in. Please check your credentials.')
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <div>
          <Input
            name="username"
            id="username"
            type="text"
            placeholder="username"
            required
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setUsername(e.target.value)
            }
            value={username}
          />
        </div>
        <div>
          <Input
            name="password"
            id="password"
            type="password"
            placeholder="password"
            required
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPassword(e.target.value)
            }
            value={password}
          />
        </div>
        <div>
          <Button
            type="blank-action"
            label="Login"
            icon={<FontAwesomeIcon icon={faRightToBracket} />}
            size="md"
          />
        </div>
        <br />
        {error && <div className={classes.errorMessage}>{error}</div>}
      </div>
    </form>
  )
}
